import { createAsyncThunk } from '@reduxjs/toolkit';
//import Config from '../../../Config';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import ProviderManager from '../../../provider/providerManager';
import { initBlock, goToPage, setSalePackages, setErrorPage , reportDWH } from './EnergyReplaceBlockSlice';


export const prepareBlockAsync = createAsyncThunk('energyReplaceBlock/prepareBlockAsync', async (data, thunkAPI) => {
    try {
        const state = thunkAPI.getState().energyReplaceBlock;
        thunkAPI.dispatch(initBlock({ energyReplaceBlock: data.energyReplaceBlock }));
        thunkAPI.dispatch(reportDWH({
          actionType: 'ActionEntry',
          status: 'Ongoing',
          messageText: 'ActionEntryResult'
        })
        )

        //thunkAPI.dispatch(goToPage('subscribersPage'));
        //thunkAPI.dispatch(goToPage('packagesPage'));
        //thunkAPI.dispatch(goToPage('sendAgreementPage'));
        //thunkAPI.dispatch(goToPage('successPage'));
        //thunkAPI.dispatch(goToPage('errorPage'));

        //thunkAPI.dispatch(setErrorPage('NOT_JET_CUSTOMER_ERROR'));
        //thunkAPI.dispatch(setErrorPage('NO_SUBSCRIBER_ERROR'));
        //thunkAPI.dispatch(setErrorPage('TAOZ_ERROR'));
        //thunkAPI.dispatch(setErrorPage('GENERAL_ERROR'));
        //thunkAPI.dispatch(setErrorPage('FUTURE_PRICE_PLAN_ERROR'));
        //thunkAPI.dispatch(setErrorPage('HAS_OPEN_ORDER_ERROR'));
        //thunkAPI.dispatch(setErrorPage('PAYMENT_ERROR'));
        //thunkAPI.dispatch(setErrorPage('DEBT_ERROR'));
        //thunkAPI.dispatch(setErrorPage('PAYMENT_AND_DEBT_ERROR'));

    } catch (error) {

    } finally {

    }
});


export const filterPackagesAsync = createAsyncThunk('energyReplaceBlock/filterPackagesAsync', async (data, thunkAPI) => {
    try {
        const state = thunkAPI.getState().energyReplaceBlock;
        const equipment = state.subscriber?.equipments.find(x=> x.productSaleType == 'Energy');
        const isSmartMeter =  (equipment?.productDescription == 'SMART');

        //smart meter - display all packages
        //basic meter - display only basic meter packages
        //filter current package
        const packages = state.salePackages.expandedValue.filter(x=> isSmartMeter || (!isSmartMeter && !!x.isSmartMeterPackage?.value == false));
        const filteredPackages = packages?.filter(x=> x.offerID.value != state.subscriber.offerId);

        thunkAPI.dispatch(setSalePackages({expandedValue: filteredPackages}));

        if (filteredPackages.length > 0) {
          thunkAPI.dispatch(reportDWH({
            actionType:'SubscriberSelectionSuccessful',
            status:'Completed',
            messageText:'SubscriberSelectionSuccessDisplay'
          }))
          thunkAPI.dispatch(goToPage('packagesPage'));
        }
        else {
          thunkAPI.dispatch(reportDWH({
            actionType:'SubscriberSelectionFailed',
            status:'Error',
            messageText:'SubscriberSelectionFailureDisplay'
          }))
          thunkAPI.dispatch(setErrorPage('NO_PACKAGES_ERROR'));
        }


    } catch (error) {

    }
});


export const getEnergyReplacePricesAsync = createAsyncThunk('energyReplaceBlock/getEnergyReplacePricesAsync', async (data, thunkAPI) => {
    try {
        thunkAPI.dispatch(showAppLoader());
        const state = thunkAPI.getState().energyReplaceBlock;
        const authentication = thunkAPI.getState().authentication;

        const equipment = state.subscriber?.equipments?.find(x=> x.productSaleType == 'Energy');
        const isSmartMeter =  (equipment?.productDescription == 'SMART');

        const params = {
            offerId: state.selectedPackage?.offerID,
            offerName: '',
            saleType: 'energy',
            personalInfo: {
                idNumber: authentication.loginData?.userDetails.IDNumber,
                lastName: authentication.loginData?.userDetails.lastName,
                firstName: authentication.loginData?.userDetails.firstName,
                otpPhone: authentication.loginData?.userDetails.contactNumber,
                ban: state.subscriber?.ban
            }
        }

        const result = await ProviderManager.getProviderData('getEnergyReplacePrices', params);
        thunkAPI.dispatch(hideAppLoader());
        const isSuccess = result?.Body?.successCatalogResult?.isSuccess;

        if (isSuccess) {
          thunkAPI.dispatch(reportDWH({
            actionType:'PlanSelectionSuccessful',
            status: 'Completed',
            messageText:'PlanSelectionSuccessDisplay'
          }));
            thunkAPI.dispatch(goToPage('sendAgreementPage'));
        }
        else {
          thunkAPI.dispatch(reportDWH({
            actionType:'PlanSelectionFailed',
            status: 'Error',
            messageText:'PlanSelectionFailureDisplay'
          }));
          thunkAPI.dispatch(setErrorPage('GET_PRICE_ERROR'));
        }

        return;

    } catch (error) {

    } finally {
        thunkAPI.dispatch(hideAppLoader());
    }
});


export const createEnergyReplaceAsync = createAsyncThunk('energyReplaceBlock/createEnergyReplaceAsync', async (data, thunkAPI) => {
    try {
        thunkAPI.dispatch(showAppLoader());
        const state = thunkAPI.getState().energyReplaceBlock;
        const authentication = thunkAPI.getState().authentication;

        const params = {
            offerId: state.selectedPackage?.offerID,
            offerName: '',
            saleType: 'energy',
            personalInfo: {
                idNumber: authentication.loginData?.userDetails.IDNumber,
                lastName: authentication.loginData?.userDetails.lastName,
                firstName: authentication.loginData?.userDetails.firstName,
                otpPhone: authentication.loginData?.userDetails.contactNumber,
                ban: state.subscriber?.ban,
                subscriberNo: state.subscriber?.subscriberNo,
                isReceivingAd: state.summaryDetails?.isReceivingAd
            },
            authorizationDetails: {
                summaryWillBeSentTo: state.summaryDetails.summaryWillBeSentTo,
                summarySmsNumber: state.summaryDetails.summarySmsNumber,
                summaryEmail: state.summaryDetails.summaryEmail,
            }
        }

        const result = await ProviderManager.getProviderData('createEnergyReplace', params);
        thunkAPI.dispatch(hideAppLoader());
        const isSuccess = result?.Body?.isSuccess;

        if (isSuccess) {
            thunkAPI.dispatch(reportDWH({
                actionType: 'AgreementSendingSuccessful',
                status: 'Completed',
                messageText: 'AgreementSendingSuccessDisplay',
            }));
            thunkAPI.dispatch(goToPage('successPage'));
        }
        else {
            thunkAPI.dispatch(reportDWH({
                actionType: 'AgreementSendingFailed',
                status: 'Error',
                messageText: 'AgreementSendingFailureDisplay',
            }));
            thunkAPI.dispatch(setErrorPage('CREATE_ENERGY_REPLACE_ERROR'));
        }

        return;

    } catch (error) {
        thunkAPI.dispatch(reportDWH({
            actionType: 'AgreementSendingFailed',
            status: 'Error',
            messageText: 'AgreementSendingFailureDisplay',
        }));
    } finally {
        thunkAPI.dispatch(hideAppLoader());
    }
});
